var _a;
class Variation {
    suffix;
    value;
    constructor(response) {
        this.suffix = response.suffix;
        this.value = response.value;
    }
    printYield() {
        const items = [];
        if (this.value < 1) {
            items.push(`±${(this.value * 100).toString()}bps`);
        }
        else {
            items.push(`±${this.value.toString()}`);
        }
        if (this.suffix === 'WPIR') {
            items.push("WPIR");
        }
        return items;
    }
    printSpread() {
        const items = [];
        items.push(`±${this.value.toString()}`);
        if (this.suffix !== undefined) {
            items.push(this.suffix);
        }
        return items;
    }
    #clone() {
        return new _a(this);
    }
    updateSuffix(newValue) {
        const clone = this.#clone();
        clone.suffix = newValue;
        return clone;
    }
    updateValue(newValue) {
        const clone = this.#clone();
        clone.value = newValue;
        return clone;
    }
}
_a = Variation;
export default Variation;
